import React from 'react';

const GeneralMessage = ({ message }) => {
  const InfoIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 18C11.5822 18 13.129 17.5308 14.4446 16.6518C15.7602 15.7727 16.7855 14.5233 17.391 13.0615C17.9965 11.5997 18.155 9.99113 17.8463 8.43928C17.5376 6.88743 16.7757 5.46197 15.6569 4.34315C14.538 3.22433 13.1126 2.4624 11.5607 2.15372C10.0089 1.84504 8.40034 2.00346 6.93853 2.60897C5.47672 3.21447 4.2273 4.23985 3.34824 5.55544C2.46919 6.87103 2 8.41775 2 10C2 12.1217 2.84285 14.1566 4.34314 15.6569C5.84344 17.1571 7.87827 18 10 18ZM10 5.5C10.1978 5.5 10.3911 5.55865 10.5556 5.66853C10.72 5.77841 10.8482 5.93459 10.9239 6.11732C10.9996 6.30005 11.0194 6.50111 10.9808 6.69509C10.9422 6.88907 10.847 7.06726 10.7071 7.20711C10.5673 7.34696 10.3891 7.4422 10.1951 7.48079C10.0011 7.51937 9.80004 7.49957 9.61732 7.42388C9.43459 7.34819 9.27841 7.22002 9.16853 7.05557C9.05865 6.89112 9 6.69778 9 6.5C9 6.23479 9.10536 5.98043 9.29289 5.79289C9.48043 5.60536 9.73478 5.5 10 5.5ZM9 9L11 9L11 14.5L9 14.5L9 9Z"
        fill="#007399"
      />
    </svg>
  );
  return (
    <div className="general-message">
      <div>
        <InfoIcon />
      </div>
      <div className="message-text">{message}</div>
    </div>
  );
};

export default GeneralMessage;
